import React, { useEffect, useState } from "react";
// import AnimatedNumbers from "react-animated-numbers";
// import { ToastContainer } from "react-toastify";
import FooterFooter from "../../components/footerfooter";
import CountUp from "react-countup";
//IMPORT DYNAMIC STYLED COMPONENT
import { StyledHeader } from "../../Styles";
import { IoDiamondOutline } from "react-icons/io5";
import { FiFilter } from "react-icons/fi";
import "./styles/newMiniMint.scss";
import { CONFIG } from "../../../config.js";
import { ABI, DashboardFunctions } from "./functions";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
import { useMoralis, useWeb3ExecuteFunction } from "react-moralis";
import ReactVisibilitySensor from "react-visibility-sensor";
import NewsLetterSection from "./component/shared/footer/newLetterSection";

//SWITCH VARIABLE FOR PAGE STYLE
const theme = "GREY"; //LIGHT, GREY, RETRO

const NewMiniMint = () => {
  const {
    authenticate,
    isAuthenticated,
    user,
    Moralis,
    setUserData,
    userError,
    isWeb3Enabled,
    account,
    ...xyz
  } = useMoralis();
  const [mintAmount, setMintAmount] = useState({
    mintQuantity: 0,
  });

  const notifySuccess = (message) =>
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  const notifyInfo = (message) =>
    toast.info(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  const notifyError = (message) =>
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });

  async function handleSide(option) {
    const { label, value } = option;
    console.log("value=", value, "label=", label);
    console.log(label);
    await setMintAmount({
      ...mintAmount,
      mintQuantity: value,
    });
  }

  const { data, error, fetch, isFetching, isLoading } =
    useWeb3ExecuteFunction();
  async function mintNFT2(val) {
    await Moralis.enableWeb3();

    const etherValue = val * 0.075;
    let options = {
      chain: CONFIG.chainID,
      contractAddress: CONFIG.smart_contract_minimoose,
      functionName: "mintMiniMoose",
      abi: ABI.mintMiniMoose,
      params: {
        _count: val,
      },
      msgValue: Moralis.Units.ETH(etherValue),
    };
    // await Moralis.enableWeb3();
    console.log("mintUser=>", user);
    try {
      const mintTransaction = await Moralis.executeFunction(options);
      console.log(
        "mintTransaction=>",
        mintTransaction,
        "mintTransactionhash",
        mintTransaction.hash
      );
      notifyInfo("Please wait for confirmation");
      await mintTransaction.wait();
      notifySuccess("Please reload after sometime to get the minted NFT");
    } catch (e) {
      console.log("mintError=>", e);
      notifyError("Oops some problem occured! Please try again later!");
    }
    if (
      typeof error?.code == "undefined" &&
      typeof error?.data != "undefined"
    ) {
      notifySuccess("Please Wait For Sometime Transaction is Successful");
    } else if (typeof error?.code != "undefined") {
      notifyError("There is some error Please Try Again Later");
    }
  }
  const customStyles = {
    option: (base, state) => ({
      ...base,
      background: "#fff",
      color: "#333",
      borderRadius: state.isFocused ? "0" : 0,
      "&:hover": {
        background: "#eee",
      },
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 0,
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
    }),
    control: (base, state) => ({
      ...base,
      padding: 2,
      height: 60,
    }),
  };
  return (
    <>
      <div className="greyscheme">
        <StyledHeader theme={theme} />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          theme="dark"
          pauseOnHover
        />
        <div className="greyscheme">
          <div className="hero_top_minimint">
            <div className="hero_top_img"></div>
          </div>
          <section className="container">
            <div className="hero_section_minimint">
              <div className="row">
                <div className="col-md-6 content_col">
                  <div className="hero_content">
                    <div
                      className="title"
                      data-aos="fade-up"
                      data-aos-delay="500"
                      data-aos-duration="5000"
                      data-aos-once="true"
                      data-aos-easing="ease-in-out"
                    >
                      <h2>Mini Moose!</h2>
                      <span className="divider"></span>
                    </div>
                    <div className="desc">
                      These Mini Moose might be adorable, but they bite. Become
                      a Moose Society Holder, Stake 2 for 90 days and get one
                      FREE. Or, you can mint one below. There's a limited amount
                      of Mini's available to mint so act quick!
                    </div>
                    <div className="button_text">
                      <div className="twice_button d-flex">
                        <button
                          className="mint"
                          onClick={() => mintNFT2(mintAmount.mintQuantity)}
                        >
                          Mint A Mini{" "}
                          <IoDiamondOutline style={{ color: "#fff" }} />
                        </button>
                        <Select
                          styles={customStyles}
                          onChange={handleSide}
                          // onChange={(option) => mintNFT2(option.value)}
                          options={[
                            { value: "1", label: "1" },
                            { value: "2", label: "2" },
                            // { value: "3", label: "3" },
                            // { value: "4", label: "4" },
                            // { value: "5", label: "5" },
                            // { value: "6", label: "6" },
                            // { value: "7", label: "7" },
                            // { value: "8", label: "8" },
                            // { value: "9", label: "9" },
                            // { value: "10", label: "10" },
                          ]}
                        />
                      </div>
                      <button
                        className="mint evolve_btn mt-3"
                        // onClick={() => mintNFT2(1)}
                      >
                        evolve your mini{" "}
                        <FiFilter
                          style={{
                            color: "#fff",
                            transform: "rotate(180deg)",
                            marginLeft: "10px",
                          }}
                        />
                      </button>
                    </div>
                    <div className="counter_number">
                      <div
                        className="counter_wrapper"
                        data-aos="fade-up"
                        data-aos-delay="800"
                        data-aos-duration="5000"
                        data-aos-once="true"
                        data-aos-easing="ease-in-out"
                      >
                        <span className="count">
                          <CountUp end={2500} start={0} delay={1}>
                            {({ countUpRef, start }) => (
                              <ReactVisibilitySensor
                                partialVisibility={false}
                                onChange={start}
                              >
                                <span ref={countUpRef} />
                              </ReactVisibilitySensor>
                            )}
                          </CountUp>
                        </span>
                        <div className="text">Mini Moose</div>
                      </div>
                      <div
                        className="counter_wrapper"
                        data-aos="fade-up"
                        data-aos-delay="800"
                        data-aos-duration="5000"
                        data-aos-once="true"
                        data-aos-easing="ease-in-out"
                      >
                        <span className="count">
                          <CountUp end={1250} start={0} delay={1}>
                            {({ countUpRef, start }) => (
                              <ReactVisibilitySensor
                                partialVisibility={false}
                                onChange={start}
                              >
                                <span ref={countUpRef} />
                              </ReactVisibilitySensor>
                            )}
                          </CountUp>
                        </span>
                        <div className="text">Hero Boxes</div>
                      </div>
                      <div
                        className="counter_wrapper"
                        data-aos="fade-up"
                        data-aos-delay="800"
                        data-aos-duration="5000"
                        data-aos-once="true"
                        data-aos-easing="ease-in-out"
                      >
                        <span className="count">
                          <CountUp end={1250} start={0} delay={1}>
                            {({ countUpRef, start }) => (
                              <ReactVisibilitySensor
                                partialVisibility={false}
                                onChange={start}
                              >
                                <span ref={countUpRef} />
                              </ReactVisibilitySensor>
                            )}
                          </CountUp>
                        </span>
                        <div className="text">Serums</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className="hero_image"
                    data-aos="fade-up"
                    data-aos-delay="500"
                    data-aos-duration="5000"
                    data-aos-once="true"
                    data-aos-easing="ease-in-out"
                  >
                    <div className="image_bg">
                      <div className="img_wrapper">
                        <img
                          src="https://moosesocietynft.io/wp-content/uploads/elementor/thumbs/108-pn7ummemiaiwrt5guq2edmyhph7ukr39ll7cg2a5l4.png"
                          alt="img"
                          data-aos="fade-up"
                          data-aos-delay="1000"
                          data-aos-duration="5000"
                          data-aos-once="true"
                          data-aos-easing="ease-in-out"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <br />
          <br />
          <NewsLetterSection />
          <FooterFooter />
        </div>
      </div>
    </>
  );
};

export default NewMiniMint;
